export default "__VITE_ASSET__6d0508a4__"